import axios from 'axios';

let prefix = "/unit-star-level"

const UnitStarLevelApi = {
	listUnitStarLevel(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getUnitStarLevel(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	archiveUnitStarLevel(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createUnitStarLevel(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateUnitStarLevel(payload) {
		return axios.post(prefix + "/update", payload)
	},
}

export default UnitStarLevelApi;